/** AdMob 原币金额精度：按 SIX ISO 4217（2026-09-17）有限白名单，未知精度保持未就绪。 */
// 来源：https://www.six-group.com/dam/download/financial-information/data-center/iso-currrency/lists/list-one.xml
// 不使用 Intl 的未知币种默认 2 位；收入先合计 micros，再仅调用一次转换。

const CURRENCIES_WITH_0_DECIMALS =
  'BIF CLP DJF GNF ISK JPY KMF KRW PYG RWF UGX UYI VND VUV XAF XOF XPF';
const CURRENCIES_WITH_2_DECIMALS =
  'AED AFN ALL AMD AOA ARS AUD AWG AZN BAM BBD BDT BMD BND BOB BOV BRL BSD BTN BWP BYN BZD CAD CDF CHE CHF CHW CNY COP COU CRC CUP CVE CZK DKK DOP DZD EGP ERN ETB EUR FJD FKP GBP GEL GHS GIP GMD GTQ GYD HKD HNL HTG HUF IDR ILS INR IRR JMD KES KGS KHR KPW KYD KZT LAK LBP LKR LRD LSL MAD MDL MGA MKD MMK MNT MOP MRU MUR MVR MWK MXN MXV MYR MZN NAD NGN NIO NOK NPR NZD PAB PEN PGK PHP PKR PLN QAR RON RSD RUB SAR SBD SCR SDG SEK SGD SHP SLE SOS SRD SSP STN SVC SYP SZL THB TJS TMT TOP TRY TTD TWD TZS UAH USD USN UYU UZS VED VES WST XAD XCD XCG YER ZAR ZMW ZWG';
const CURRENCIES_WITH_3_DECIMALS = 'BHD IQD JOD KWD LYD OMR TND';
const CURRENCIES_WITH_4_DECIMALS = 'CLF UYW';

export function currencyMinorUnitExponent(currency: string): number | null {
  if (!/^[A-Z]{3}$/.test(currency)) return null;
  if (CURRENCIES_WITH_0_DECIMALS.split(' ').includes(currency)) return 0;
  if (CURRENCIES_WITH_2_DECIMALS.split(' ').includes(currency)) return 2;
  if (CURRENCIES_WITH_3_DECIMALS.split(' ').includes(currency)) return 3;
  if (CURRENCIES_WITH_4_DECIMALS.split(' ').includes(currency)) return 4;
  return null;
}

export function microsToMinorUnits(micros: bigint, currency: string): string | null {
  const exponent = currencyMinorUnitExponent(currency);
  if (exponent === null) return null;
  const absoluteNumerator = (micros < 0n ? -micros : micros) * 10n ** BigInt(exponent);
  const rounded = (absoluteNumerator + 500_000n) / 1_000_000n;
  return (micros < 0n ? -rounded : rounded).toString();
}
